import axios from 'axios';

// 创建axios实例（保持与原有this.axios相同的配置）
const instance = axios.create();

// 请求拦截器：动态重写URL
instance.interceptors.request.use(config => {
  if (process.env.NODE_ENV === 'production') {
    const originalUrl = config.url;
    const ruleMap = window.APP_CONFIG?.API_PROXY_MAP || {};
    
    // 查找匹配的前缀规则
    for (const [prefix, target] of Object.entries(ruleMap)) {
      if (originalUrl.startsWith(prefix)) {
        config.url = originalUrl.replace(prefix, target);
        break;
      }
    }
  }
  return config;
});

export default instance;